import { NO_DATA_PLACEHOLDER_DASH, Typography } from '@occc-app/design-system';

export const EmptyValue = () => (
  <Typography component='span' variant='body2' color='text.disabled'>
    {NO_DATA_PLACEHOLDER_DASH}
  </Typography>
);
